import Calculator from './conponents/Calculator/Calculator';

function App() {
  return (
    <main>
      <div className='container'>
        <Calculator/>
      </div>
    </main>
  );
}

export default App;
